import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PaywallPaymentSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PaywallPaymentSettingsPage" */ "@circle-react/components/SettingsApp/PaywallPaymentSettings"
    ),
);

export const PaywallPaymentSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PaywallPaymentSettingsComponent />
  </Suspense>
);
